import { Directive, ElementRef, HostBinding, HostListener, Input } from '@angular/core';
import { ElementConfig } from './ElementConfig/element-config';

@Directive({
  selector: '[rlAnnotatorFile]'
})
export class AnnotatorFileDirective{
 
  @Input() scrollContainer : string;
  @Input() type? : 'PDF' = 'PDF';

  constructor(private element : ElementRef) { }

  @HostBinding('cursor')
  cursor : any;
  
  @HostListener('lgntoann.annotation.scroll', ['$event'])
  scrollToAnnotation(e){
    let scrollTo = this.element.nativeElement.querySelector(`[data-annotation-id='${e.detail}']`).parentElement.parentElement.offsetTop;
    this.element.nativeElement.querySelector("." + this.scrollContainer).scrollTop = scrollTo;
  }

  getConfig(element: ElementRef): ElementConfig {
    switch(this.type){
      default : return new ElementConfig(element);
    }
  }
}
